module.exports = __webpack_public_path__ + "static/media/data-slider-image-2.62ab5b99.png";